import HFCLLightTheme from '../../token/theme/HFCLLightTheme';
import HFCLDarkTheme from '../../token/theme/HFCLDarkTheme';


const getTheme = (themeType) => {
  switch (themeType) {
    case 'LIGHT': {
      return HFCLLightTheme;
    }
    case 'DARK': {
      return HFCLDarkTheme;
    }
    default: {
      return HFCLLightTheme;
    }
  }
};

export default getTheme;
